import g1 from "./galleryImages/g1.jpeg";
import g7 from "./galleryImages/g7.jpeg";
import g3 from "./galleryImages/g3.jpeg";
import g4 from "./galleryImages/g4.jpeg";
import g5 from "./galleryImages/g5.jpeg";
import g6 from "./galleryImages/g6.jpeg";
// import g7 from "./galleryImages/g7.jpeg";
import g8 from "./galleryImages/g8.jpeg";
import g9 from "./galleryImages/g9.jpeg";
import g10 from "./galleryImages/g10.jpeg";
import g11 from "./galleryImages/g11.jpeg";
import g20 from "./galleryImages/g20.jpeg";
import g21 from "./galleryImages/g21.jpeg";
import g22 from "./galleryImages/g22.jpeg";

export const galleryImages = [
  g20,
  g1,
  g5,
  g11,
  g21,
  g10,
  g4,
  g6,
  g22,
  g3,
  g9,
  g8,
];